export default __webpack_public_path__ + "static/media/authImg1.091d4b75.jpg";